import React, { useState } from 'react'

import { Space } from 'antd'
import CoinGroupDetail from '../CoinGroupDetail'
import PositionOpen from '../PositionOpen'
import WaitOrder from '../WaitOrder'

const ExchangeRealtime = ({ title, type }: any) => {
	const [show, setShow] = useState(false)

	return (
		<Space direction="vertical" style={{ width: '100%' }}>
			<CoinGroupDetail />
			<PositionOpen title={title} type={type} />
			<WaitOrder title={'미체결내역'} />
		</Space>
	)
}

export default ExchangeRealtime
